import { z } from 'zod'

import { isHeaderWithAttachment } from 'apps/whatsApp/MessageTemplates/helpers'
import { FlowChartImagePreview } from 'common/builder/components/chart/FlowChart/types/FlowChartImagePreview'
import { WaMessageTemplateHeaderType, messageTemplate } from 'shared/api/requests/whatsApp/schemas'

export function getImagePreviewFromTemplate(
  template: z.infer<typeof messageTemplate> | null,
): FlowChartImagePreview | null {
  if (
    !template ||
    !isHeaderWithAttachment(template.header) ||
    template.header.type !== WaMessageTemplateHeaderType.IMAGE
  ) {
    return null
  }

  return {
    url: template.header.url,
    size: null,
  }
}
